<template>
  <div class="matching-result">
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <template
            v-if="
              match &&
                match.result &&
                match.result.resultSupplyUnitConnectionsList &&
                match.result.resultSupplyUnitConnectionsList[0]
            "
          >
            <div class="status-green"></div>
          </template>
          <template
            v-else-if="
              match &&
                match.result &&
                match.result.FirebirdResult &&
                (match.result.FirebirdResult.AGS27 ||
                  match.result.FirebirdResult.Projekt_ID)
            "
          >
            <div class="status-yellow"></div>
          </template>
          <template v-else>
            <div class="status-red"></div>
          </template>
          <StatCard label="Vertrags-Nr." :value="match.contractId" />
          <StatCard label="Home-ID" :value="match.homeId" />
          <StatCard label="AGS-Key" :value="match.agsKey" />
          <StatCard label="PLZ" :value="match.zip" />
          <StatCard label="Ort" :value="match.city" />
          <StatCard label="Straße" :value="match.street" />
          <StatCard label="Hausnummer" :value="match.housenumber" />
          <StatCard
            label="Hausnummernzusatz"
            :value="match.housenumbersupplement"
          />
          <StatCard label="ONT-Serienr." :value="match.ontSn" />
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col>
              <v-card>
                <v-card-title>
                  <h3>Ergebnis PAST:</h3>
                </v-card-title>
                <v-card-text>
                  <template
                    v-if="
                      match &&
                        match.result &&
                        match.result.resultSupplyUnitConnectionsList &&
                        match.result.resultSupplyUnitConnectionsList[0]
                    "
                  >
                    <v-alert
                      type="success"
                      prominent
                      border="left"
                    >
                      Eintrag vorhanden
                    </v-alert>
                    <v-simple-table>
                      <tbody>
                        <tr>
                          <td><b>Home-ID:</b></td>
                          <td>
                            {{
                              match.result.resultSupplyUnitConnectionsList[0].homeId
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td><b>AGS-Key:</b></td>
                          <td>
                            {{
                              match.result.resultSupplyUnitConnectionsList[0]
                                .gAgsKey ||
                                match.result.resultSupplyUnitConnectionsList[0].ags27
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td><b>Vertrags-Nr.:</b></td>
                          <td>
                            {{
                              match.result.resultSupplyUnitConnectionsList[0]
                                .contractId
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td><b>ONT-SN:</b></td>
                          <td>
                            {{
                              match.result.resultSupplyUnitConnectionsList[0].ontSn
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td><b>First Online Date:</b></td>
                          <td>
                            {{
                              match.result.resultSupplyUnitConnectionsList[0]
                                .firstOnlineCheckDate
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td><b>Last Online Date:</b></td>
                          <td>
                            {{
                              match.result.resultSupplyUnitConnectionsList[0]
                                .lastOnlineSeenCheckDate
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td><b>Vario ONT-Resource-ID:</b></td>
                          <td>
                            {{
                              match.result.resultSupplyUnitConnectionsList[0]
                                .varioOntResourceId
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td><b>MSAN:</b></td>
                          <td>
                            {{
                              match.result.resultSupplyUnitConnectionsList[0]
                                .verifiedMsanHostname
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td><b>Device-Port:</b></td>
                          <td>
                            {{
                              match.result.resultSupplyUnitConnectionsList[0]
                                .verifiedDevicePort
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td><b>Device-Slot:</b></td>
                          <td>
                            {{
                              match.result.resultSupplyUnitConnectionsList[0]
                                .verifiedDeviceSlot
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </template>
                  <template v-else>
                    <v-alert
                      type="error"
                      prominent
                      border="left"
                    >
                      Eintrag nicht vorhanden
                    </v-alert>
                    <br />
                    <br />
                    <v-card>
                      <v-card-title> Neuer Eintrag </v-card-title>
                      <v-card-text>
                        <v-alert
                          v-if="
                            match &&
                              match.result &&
                              match.result.FirebirdResult &&
                              (match.result.FirebirdResult.AGS27 ||
                                match.result.FirebirdResult.Projekt_ID)
                          "
                          dense
                          outlined
                          type="success"
                        >
                          <b>AGS-Key: </b>
                          <span
                            v-if="
                              match.result &&
                                match.result.FirebirdResult &&
                                match.result.FirebirdResult.AGS27
                            "
                          >
                            {{ match.result.FirebirdResult.AGS27 }}</span>
                          <br />
                          <b>Projekt-ID: </b>
                          <span
                            v-if="
                              match.result &&
                                match.result.FirebirdResult &&
                                match.result.FirebirdResult.Projekt_ID
                            "
                          >
                            {{ match.result.FirebirdResult.Projekt_ID }}</span>
                        </v-alert>
                        <!-- <v-btn
                                v-if="
                                  !match.result.FirebirdResult ||
                                    !match.result.FirebirdResult.Projekt_ID ||
                                    !match.result.FirebirdResult.AGS27
                                "
                              >
                                AGS-Key / Projekt-ID ermitteln
                              </v-btn> -->
                        <v-btn
                          v-if="
                            !match.result.FirebirdResult ||
                              !match.result.FirebirdResult.Projekt_ID ||
                              !match.result.FirebirdResult.AGS27
                          "
                          @click="addressDialogVisible = true"
                        >
                          Adresssuche
                        </v-btn>
                        <v-form ref="form">
                          <v-text-field
                            v-model="newContractId"
                            label="Vertrags-Nr.:"
                            required
                          ></v-text-field>
                          <v-text-field
                            v-model="newAgsKey"
                            label="AGS-Key"
                            required
                          ></v-text-field>
                          <v-text-field
                            v-model="newProjectId"
                            label="Projekt-ID"
                            required
                          ></v-text-field>
                          <v-text-field
                            v-model="newHomeId"
                            :label="homeIdLabel"
                            required
                          ></v-text-field>
                          <v-btn
                            v-if="!newOntSn"
                            @click="setBpPlusValue"
                          >
                            BP+ Eintrag
                          </v-btn>
                          <v-text-field
                            v-model="newOntSn"
                            :label="ontSnLabel"
                            :value="match.result.input.ontSn"
                            :deactivated="bpPlusActive"
                            required
                          ></v-text-field>
                          <v-text-field
                            v-model="newSourceFileName"
                            label="Name Quelldatei"
                            required
                          ></v-text-field>
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn color="primary" @click="saveSupplyUnitConnection()">
                          Eintrag generieren
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col>
              <!-- <b>Ergebnis Merged-KBL:</b>
                    <pre>
                          {{ match.result.resultMergedKblTable }}
                        </pre>
                    <hr />
                    <b>Ergebnis varioCRM:</b> -->
              <v-card>
                <v-card-title><h3>Ergebnis varioCRM:</h3></v-card-title>
                <v-card-text>
                  <v-simple-table v-if="match.result && match.result.FirebirdResult">
                    <tbody>
                      <tr>
                        <td><b>Vertrags-Nr.:</b></td>
                        <td>
                          {{ match.result.FirebirdResult.CO_ID }}
                        </td>
                      </tr>
                      <tr>
                        <td><b>Kunden-Nr.:</b></td>
                        <td>
                          {{ match.result.FirebirdResult.CUSTOMER_ID }}
                        </td>
                      </tr>
                      <tr>
                        <td><b>AGS-Key:</b></td>
                        <td>
                          {{ match.result.FirebirdResult.AGS27 }}
                        </td>
                      </tr>
                      <tr>
                        <td><b>Home-ID:</b></td>
                        <td>
                          {{ match.result.FirebirdResult.Home_ID }}
                        </td>
                      </tr>
                      <tr>
                        <td><b>Projekt-ID:</b></td>
                        <td>
                          {{ match.result.FirebirdResult.Projekt_ID }}
                        </td>
                      </tr>
                      <tr>
                        <td><b>Unterschriftsdatum:</b></td>
                        <td>
                          {{ match.result.FirebirdResult.DATE_SIGNED }}
                        </td>
                      </tr>
                      <tr>
                        <td><b>Aktivierungsdatum:</b></td>
                        <td>
                          {{ match.result.FirebirdResult.DATE_ACTIVE }}
                        </td>
                      </tr>
                      <tr>
                        <td><b>Deaktivierungsdatum:</b></td>
                        <td>
                          {{ match.result.FirebirdResult.DATE_DEACTIVE }}
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                  <template v-if="match.result && match.result.FirebirdResult && match.result.FirebirdResult.ontGponSn">
                    <v-simple-table>
                      <tbody>
                        <tr>
                          <td><b>ONT varioResource:</b></td>
                          <td>
                            {{ match.result.FirebirdResult.ontGponSn }}
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                    <br />
                    <v-btn @click="getOntInfos(match.result.FirebirdResult.ontGponSn)">
                      Mehr Infos
                    </v-btn>
                    <br />
                    <v-alert
                      v-if="ontInfos && ontInfos.length"
                      class="my-2"
                      type="info"
                      outlined
                    >
                      <v-simple-table v-if="ontInfos && ontInfos.length && ontInfos[0]" dense>
                        <tbody>
                          <tr>
                            <td><b>Home-ID:</b></td>
                            <td>
                              {{
                                ontInfos[0].homeId
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td><b>AGS-Key:</b></td>
                            <td>
                              {{
                                ontInfos[0]
                                  .gAgsKey ||
                                  ontInfos[0].ags27
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td><b>ONT-SN:</b></td>
                            <td>
                              {{
                                ontInfos[0].ontSn
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td><b>First Online Date:</b></td>
                            <td>
                              {{
                                ontInfos[0]
                                  .firstOnlineCheckDate
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td><b>Last Online Date:</b></td>
                            <td>
                              {{
                                ontInfos[0]
                                  .lastOnlineSeenCheckDate
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td><b>Vario ONT-Resource-ID:</b></td>
                            <td>
                              {{
                                ontInfos[0]
                                  .varioOntResourceId
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td><b>MSAN:</b></td>
                            <td>
                              {{
                                ontInfos[0]
                                  .verifiedMsanHostname
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td><b>Device-Port:</b></td>
                            <td>
                              {{
                                ontInfos[0]
                                  .verifiedDevicePort
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td><b>Device-Slot:</b></td>
                            <td>
                              {{
                                ontInfos[0]
                                  .verifiedDeviceSlot
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-alert>
                  </template>
                  <v-alert
                    v-if="!match.result.FirebirdResult"
                    type="error"
                    prominent
                    border="left"
                  >
                    Kein Vertrag vorhanden
                  </v-alert>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-dialog
      v-if="addressDialogVisible"
      v-model="addressDialogVisible"
      width="1400"
    >
      <v-card>
        <v-card-title> Adresse auswählen </v-card-title>

        <v-card-text>
          <AvailabilityForm />
        </v-card-text>
        <v-card-actions>
          <v-btn color="secondary" @click="userSelectHeaderForCol">
            Abbrechen
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="selectHeaderPromise"
            color="primary"
            :disabled="!selectedHeader"
            @click="userSelectHeaderForCol"
          >
            Auswählen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import StatCard from '@/components/constructionProjects/Statcard.vue';
import AvailabilityForm from '@/components/constructionProjects/AvailabilityForm.vue';
import NotificationObject from '@/main/NotificationObject.js';
import { HTTP } from '@/main/httpClient.js';

export default {
  components: {
    StatCard,
    AvailabilityForm
  },
  props: {
    match: {
      type: Object,
      required: false,
      default: undefined
    },
    filename: {
      type: String,
      required: false,
      default: undefined
    }
  },
  data: () => ({
    newHomeId: undefined,
    newOntSn: undefined,
    newContractId: undefined,
    newAgsKey: undefined,
    newProjectId: undefined,
    addressDialogVisible: false,
    homeIdLabel: 'Home-ID',
    ontSnLabel: 'ONT-SN',
    newSourceFileName: '',
    ontInfos: undefined,
    bpPlusActive: false
  }),
  watch: {
    newAgsKey: {
      handler(newVal) {
        if (newVal && this.newProjectId) {
          this.newHomeId = this.generateHomeId(
            this.newProjectId,
            newVal
          );
          this.homeIdLabel = 'Home-ID generiert';
        }
      }
    },
    newProjectId: {
      handler(newVal) {
        if (newVal && this.newAgsKey) {
          this.newHomeId = this.generateHomeId(
            newVal,
            this.newAgsKey
          );
          this.homeIdLabel = 'Home-ID generiert';
        }
      },
    },
    match: {
      deep: true,
      handler(newVal) {
        if (
          newVal &&
          newVal.result &&
          newVal.result.FirebirdResult &&
          newVal.result.FirebirdResult.CO_ID
        ) {
          this.newContractId = newVal.result.FirebirdResult.CO_ID;
        }
        if (
          newVal &&
          newVal.result &&
          newVal.result.FirebirdResult &&
          newVal.result.FirebirdResult.AGS27
        ) {
          this.newAgsKey = newVal.result.FirebirdResult.AGS27;
        }
        if (
          newVal &&
          newVal.result &&
          newVal.result.FirebirdResult &&
          newVal.result.FirebirdResult.Projekt_ID
        ) {
          this.newProjectId = newVal.result.FirebirdResult.Projekt_ID;
        }
        if (
          newVal &&
          newVal.result &&
          newVal.result.FirebirdResult &&
          newVal.result.FirebirdResult.Home_ID
        ) {
          this.newHomeId = newVal.result.FirebirdResult.Home_ID;
          this.homeIdLabel = 'Home-ID aus varioCRM Installationsadresse übernommen';
        }
        if (
          newVal &&
          newVal.result &&
          newVal.result.FirebirdResult &&
          newVal.result.FirebirdResult.Projekt_ID &&
          newVal.result.FirebirdResult.AGS27 &&
          !newVal.result.FirebirdResult.Home_ID
        ) {
          this.newHomeId = this.generateHomeId(
            newVal.result.FirebirdResult.Projekt_ID,
            newVal.result.FirebirdResult.AGS27
          );
          this.homeIdLabel = 'Home-ID generiert';
        }
        if (newVal && newVal.ontSn) {
          this.newOntSn = this.validateOntSn(newVal.ontSn);
        }
        if (this.filename) {
          this.newSourceFileName = this.filename;
        }
      }
    },
  },
  mounted() {
    if (
      this.match &&
      this.match.result &&
      this.match.result.FirebirdResult &&
      this.match.result.FirebirdResult.CO_ID
    ) {
      this.newContractId = this.match.result.FirebirdResult.CO_ID;
    }
    if (
      this.match &&
      this.match.result &&
      this.match.result.FirebirdResult &&
      this.match.result.FirebirdResult.AGS27
    ) {
      this.newAgsKey = this.match.result.FirebirdResult.AGS27;
    }
    if (
      this.match &&
      this.match.result &&
      this.match.result.FirebirdResult &&
      this.match.result.FirebirdResult.Projekt_ID
    ) {
      this.newProjectId = this.match.result.FirebirdResult.Projekt_ID;
    }
    if (
      this.match &&
      this.match.result &&
      this.match.result.FirebirdResult &&
      this.match.result.FirebirdResult.Home_ID
    ) {
      this.newHomeId = this.match.result.FirebirdResult.Home_ID;
      this.homeIdLabel = 'Home-ID aus varioCRM Installationsadresse übernommen';
    }
    if (
      this.match &&
      this.match.result &&
      this.match.result.FirebirdResult &&
      this.match.result.FirebirdResult.Projekt_ID &&
      this.match.result.FirebirdResult.AGS27 &&
      !this.match.result.FirebirdResult.Home_ID
    ) {
      this.newHomeId = this.generateHomeId(
        this.match.result.FirebirdResult.Projekt_ID,
        this.match.result.FirebirdResult.AGS27
      );
      this.homeIdLabel = 'Home-ID generiert';
    }
    if (this.match && this.match.ontSn) {
      this.newOntSn = this.validateOntSn(this.match.ontSn);
    }
    if (this.filename) {
      this.newSourceFileName = this.filename;
    }
  },
  methods: {
    generateHomeId(id, key) {
      const paddedId = String(id.trim() || 0).padStart(5, '0');
      const timestamp = String(Math.floor(Date.now() / 1000));
      return `H${paddedId}${key.trim()}N${timestamp}`;
    },
    validateOntSn(ontSn) {
      if (typeof ontSn !== 'string') {
        return '';
      }
      const str = ontSn.trim();
      const isValid12 = /^GNXS[0-9a-fA-F]{8}$/.test(str);
      const isValid8 = /^[0-9a-fA-F]{8}$/.test(str);
      if (isValid12) {
        this.ontSnLabel = 'ONT-SN aus Excel übernommen';
        return str;
      }
      if (isValid8) {
        this.ontSnLabel = 'ONT-SN rekonstruirt aus Input(!)';
        return 'GNXS' + str;
      }
      return '';
    },
    saveSupplyUnitConnection: function () {
      if (this.newHomeId && this.newOntSn && this.newAgsKey) {
        HTTP.get('/past/geo/create-supply-unit-connection', {
          params: {
            gAgs: this.newAgsKey,
            homeId: this.newHomeId,
            gfNumber: '1',
            taLocation: 'Keller',
            mfgSplicePanel: '1',
            mfgPanelPort: '1',
            mfgDamping: '-',
            ontSn: this.newOntSn,
            proofOfInstallation: '-',
            otdrProtocol: '-',
            remark: this.newSourceFileName
              ? this.newSourceFileName
              : 'KBL-UPLOAD ohne Dateiname',
            contractId: this.newContractId ? this.newContractId : '',
            lastEditor: this.$auth.user().userName
          }
        })
          .then((resp) => {
            if (resp && resp.data) {
              this.$store.commit(
                'addNotification',
                new NotificationObject('success', resp.data.message)
              );
            } else if (resp) {
              this.$store.commit(
                'addNotification',
                new NotificationObject('error', resp)
              );
            }
          })
          .catch((err) =>
            this.$store.commit(
              'addNotification',
              new NotificationObject('error', err.response.data)
            )
          )
          .finally(() => {});
      } else {
        this.$store.commit(
          'addNotification',
          new NotificationObject(
            'error',
            'Es wurden nicht alle Pflichtfelder ausgefüllt, bitte Eingabe überprüfen.'
          )
        );
      }
    },
    getOntInfos(ontSn) {
      if (ontSn) {
        HTTP.get('/past/geo/past-ont', {
          params: {
            ontSn: ontSn
          }
        })
          .then((resp) => {
            if (resp && resp.data) {
              this.ontInfos = resp.data;
              this.$store.commit(
                'addNotification',
                new NotificationObject('success', resp.data.message)
              );
            } else if (resp) {
              this.$store.commit(
                'addNotification',
                new NotificationObject('error', resp)
              );
            }
          })
          .catch((err) =>
            this.$store.commit(
              'addNotification',
              new NotificationObject('error', err.response.data)
            )
          )
          .finally(() => {});
      } else {
        this.$store.commit(
          'addNotification',
          new NotificationObject(
            'error',
            'ONT konnte nicht in PAST gefunden werden'
          )
        );
      }
    },
    setBpPlusValue() {
      if (this.newAgsKey) {
        this.newOntSn = 'BP_Plus ' + this.newAgsKey;
        this.bpPlusActive = true;
      } else {
        this.$store.commit(
          'addNotification',
          new NotificationObject(
            'error',
            'Zur Speicherung eines BP+ Eintrages ist ein AGS-Key erforderlich!'
          )
        );
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.matching-result {
  border: 2px solid #ddd;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 10px;
}
.matching-result {
.status-green {
    width: 30px !important;
    height: 30px;
    background-color: #80ed99;
    border-radius: 50%;
    box-shadow: 0 0 4px 1px #80ed99;
    flex: none;
  }
  .status-red {
    width: 30px !important;
    height: 30px;
    background-color: #ff6b6b;
    border-radius: 50%;
    box-shadow: 0 0 4px 1px #ff6b6b;
    flex: none;
  }
  .status-yellow {
    width: 30px !important;
    height: 30px;
    background-color: #ffe100;
    border-radius: 50%;
    box-shadow: 0 0 4px 1px #ffe100;
    flex: none;
  }
  .status-grey {
    width: 30px;
    height: 30px;
    background-color: #aaa;
    border-radius: 50%;
    box-shadow: 0 0 4px 1px #aaa;
  }
  .status-white {
    width: 30px;
    height: 30px;
    background-color: #fff;
    border-radius: 50%;
    box-shadow: 0 0 4px 1px #aaa;
  }
}
</style>
